/* LOMEAR legacy PDP compatibility. Deliberately scoped to legacy roots. */
(() => {
  const legacy = document.querySelector('[data-lomear-legacy]');
  if (!legacy || legacy.dataset.legacyCompatReady === 'true') return;
  legacy.dataset.legacyCompatReady = 'true';
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(cents) / 100);

  const mixedRapiSelection = form => {
    const selected = form?.querySelector('input[name^="rapi-bundles-deal"]:checked')?.closest('.rapi-bundles__bar');
    if (!selected || !form.classList.contains('rapi-bundle-has-different-variants')) return null;
    const rows = [...selected.querySelectorAll('.rapi-bundles__bar-variant')];
    const selections = rows.map(row => [...row.querySelectorAll('select')].map(select => select.value));
    return new Set(selections.map(values => values.join('|'))).size > 1 ? selections : null;
  };

  const addMixedRapiSelection = async (form, selections, button) => {
    if (form.dataset.mixedRapiSubmitting === 'true') return;
    form.dataset.mixedRapiSubmitting = 'true';
    const originalLabel = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Ajout de votre sélection…'; }
    try {
      const root = form.closest('[data-lomear-legacy]');
      const product = JSON.parse(root?.querySelector('[data-product-json]')?.textContent || '{}');
      const pack = root?.querySelector('[data-option-select]')?.value;
      const counts = new Map();
      selections.forEach(values => {
        const variant = product.variants?.find(item => item.options?.includes(pack) && values.every(value => item.options?.includes(value)));
        if (!variant) throw new Error('Variante iPhone/Android introuvable');
        counts.set(variant.id, (counts.get(variant.id) || 0) + 1);
      });
      const properties = {};
      form.querySelectorAll('input[name^="properties["]:not(:disabled)').forEach(input => {
        const match = input.name.match(/^properties\[(.*)\]$/);
        if (match && input.value) properties[match[1]] = input.value;
      });
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [...counts].map(([id, quantity]) => ({ id, quantity, properties })) }),
      });
      if (!response.ok) throw new Error('La sélection mixte n’a pas pu être ajoutée');
      window.location.assign('/cart');
    } catch (error) {
      form.dataset.mixedRapiSubmitting = 'false';
      if (button) { button.disabled = false; button.textContent = originalLabel; }
      window.alert(error.message || 'Impossible d’ajouter cette sélection');
    }
  };

  legacy.addEventListener('click', event => {
    const button = event.target.closest('.product-form button[name="add"],.product-form button[type="submit"]');
    const form = button?.closest('.product-form');
    const selections = mixedRapiSelection(form);
    if (!selections) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addMixedRapiSelection(form, selections, button);
  }, true);

  legacy.addEventListener('submit', event => {
    const form = event.target.closest('.product-form');
    const selections = mixedRapiSelection(form);
    if (!selections) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addMixedRapiSelection(form, selections, form.querySelector('button[name="add"],button[type="submit"]'));
  }, true);

  const dataNode = legacy.querySelector('[data-product-json]');
  if (!dataNode) return;
  const product = JSON.parse(dataNode.textContent || '{}');
  const selects = [...legacy.querySelectorAll('[data-option-select]')];
  const radios = [...legacy.querySelectorAll('[data-option-radio]')];

  const updateVariant = () => {
    const idInput = legacy.querySelector('input[name="id"]');
    const button = legacy.querySelector('.aera-atc, .product-form button[name="add"]');
    const sticky = legacy.querySelector('[data-sticky-atc]');
    const chosen = selects.length
      ? selects.map(select => select.value)
      : [...new Set(radios.map(radio => radio.dataset.optionIndex))].map(index => legacy.querySelector(`[data-option-radio][data-option-index="${index}"]:checked`)?.value);
    const variant = !selects.length && !radios.length
      ? product.variants?.find(item => String(item.id) === String(idInput?.value || ''))
        || product.variants?.find(item => item.available)
        || product.variants?.[0]
      : product.variants?.find(item => item.options.every((value, index) => value === chosen[index]));
    if (!variant) {
      if (idInput) idInput.value = '';
      if (button) { button.disabled = true; button.textContent = 'Combinaison indisponible'; }
      if (sticky) { sticky.disabled = true; sticky.textContent = 'Combinaison indisponible'; }
      legacy.dataset.variantState = 'unavailable';
      return;
    }
    legacy.dataset.variantState = variant.available ? 'available' : 'sold-out';
    if (idInput) idInput.value = String(variant.id);
    const quantity = legacy.querySelector('[data-product-quantity]');
    const bundleTotal = Number(legacy.dataset.bundleTotalCents);
    const displayedPrice = quantity && !quantity.disabled && Number.isFinite(bundleTotal) ? bundleTotal : variant.price;
    if (button) {
      const label = button.classList.contains('aera-atc') ? 'Ajouter AÉRA™' : 'Ajouter au panier';
      button.disabled = !variant.available;
      button.textContent = variant.available ? `${label} · ${money(displayedPrice)}` : 'Épuisé';
    }
    if (sticky) {
      sticky.disabled = !variant.available;
      sticky.textContent = variant.available ? `Ajouter au panier · ${money(displayedPrice)}` : 'Épuisé';
    }
    const price = legacy.querySelector('[data-product-price]');
    if (price) price.textContent = money(variant.price);
  };
  selects.forEach(select => select.addEventListener('change', updateVariant));
  radios.forEach(radio => radio.addEventListener('change', updateVariant));
  updateVariant();

  const refreshRapiCta = candidate => {
    const selected = candidate || legacy.querySelector('input[name^="rapi-bundles-deal"]:checked')?.closest('.rapi-bundles__bar');
    const bars = [...(selected?.closest('.rapi-bundles')?.querySelectorAll('.rapi-bundles__bar') || [])];
    const index = bars.indexOf(selected);
    if (location.pathname === '/products/pommeau-douche-filtrant' && index >= 0) {
      const mapped = product.variants?.[index];
      const idInput = legacy.querySelector('.product-form input[name="id"]');
      if (mapped && idInput) idInput.value = String(mapped.id);
    }
    const nativeOffer = [...legacy.querySelectorAll('[data-bundle-quantity]')][index];
    const nativeQuantity = legacy.querySelector('[data-product-quantity]');
    if (nativeOffer && nativeQuantity && nativeQuantity.value !== String(nativeOffer.value)) nativeQuantity.value = String(nativeOffer.value);
    const rawPrice = selected?.querySelector('.rapi-money')?.textContent?.trim();
    if (!rawPrice) return;
    const displayPrice = rawPrice.replace(/^€\s*/, '') + ' €';
    const button = legacy.querySelector('.aera-atc, .product-form button[name="add"]');
    const label = button?.classList.contains('aera-atc') ? 'Ajouter AÉRA™' : 'Ajouter au panier';
    const nextLabel = `${label} · ${displayPrice}`;
    if (button && !button.disabled && button.textContent !== nextLabel) button.textContent = nextLabel;
  };

  let rapiFrame = 0;
  const syncRapi = () => {
    const bar = legacy.querySelector('.rapi-bundles__bar');
    const deal = legacy.querySelector('input[name^="rapi-bundles-deal"]:checked');
    const property = legacy.querySelector('input[name="properties[__rapi_offer]"]:not(:disabled),input[name="properties[_rapi_bundles]"]:not(:disabled)');
    const ready = Boolean(bar && deal && property);
    if (legacy.classList.contains('has-rapi') !== ready) legacy.classList.toggle('has-rapi', ready);
    const quantity = legacy.querySelector('[data-product-quantity]');
    if (quantity) quantity.disabled = false;
    if (ready) refreshRapiCta();
  };
  syncRapi();
  new MutationObserver(() => {
    cancelAnimationFrame(rapiFrame);
    rapiFrame = requestAnimationFrame(syncRapi);
  }).observe(legacy, { childList: true, subtree: true, characterData: true });
  legacy.addEventListener('change', event => {
    if (event.target.closest('.rapi-bundles')) requestAnimationFrame(syncRapi);
  });
  legacy.querySelector('[data-sticky-atc]')?.addEventListener('click', () => legacy.querySelector('button[name="add"]')?.click());
})();
